/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationUser } from './ApplicationUser';
import {
    ApplicationUserFromJSON,
    ApplicationUserFromJSONTyped,
    ApplicationUserToJSON,
    ApplicationUserToJSONTyped,
} from './ApplicationUser';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { ImportStagingRecord } from './ImportStagingRecord';
import {
    ImportStagingRecordFromJSON,
    ImportStagingRecordFromJSONTyped,
    ImportStagingRecordToJSON,
    ImportStagingRecordToJSONTyped,
} from './ImportStagingRecord';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';
import type { ImportMapping } from './ImportMapping';
import {
    ImportMappingFromJSON,
    ImportMappingFromJSONTyped,
    ImportMappingToJSON,
    ImportMappingToJSONTyped,
} from './ImportMapping';
import type { ImportRowError } from './ImportRowError';
import {
    ImportRowErrorFromJSON,
    ImportRowErrorFromJSONTyped,
    ImportRowErrorToJSON,
    ImportRowErrorToJSONTyped,
} from './ImportRowError';
import type { ImportStatus } from './ImportStatus';
import {
    ImportStatusFromJSON,
    ImportStatusFromJSONTyped,
    ImportStatusToJSON,
    ImportStatusToJSONTyped,
} from './ImportStatus';
import type { ImportConfiguration } from './ImportConfiguration';
import {
    ImportConfigurationFromJSON,
    ImportConfigurationFromJSONTyped,
    ImportConfigurationToJSON,
    ImportConfigurationToJSONTyped,
} from './ImportConfiguration';
import type { FileUpload } from './FileUpload';
import {
    FileUploadFromJSON,
    FileUploadFromJSONTyped,
    FileUploadToJSON,
    FileUploadToJSONTyped,
} from './FileUpload';
import type { ImportGroup } from './ImportGroup';
import {
    ImportGroupFromJSON,
    ImportGroupFromJSONTyped,
    ImportGroupToJSON,
    ImportGroupToJSONTyped,
} from './ImportGroup';

/**
 * 
 * @export
 * @interface ImportSession
 */
export interface ImportSession {
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportSession
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ImportSession
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportSession
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    userId?: string;
    /**
     * 
     * @type {ApplicationUser}
     * @memberof ImportSession
     */
    user?: ApplicationUser;
    /**
     * 
     * @type {ImportType}
     * @memberof ImportSession
     */
    importType?: ImportType;
    /**
     * 
     * @type {ImportStatus}
     * @memberof ImportSession
     */
    status?: ImportStatus;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof ImportSession
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    importGroupId?: string | null;
    /**
     * 
     * @type {ImportGroup}
     * @memberof ImportSession
     */
    importGroup?: ImportGroup;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    groupOrder?: number | null;
    /**
     * 
     * @type {Array<FileUpload>}
     * @memberof ImportSession
     */
    fileUploads?: Array<FileUpload> | null;
    /**
     * 
     * @type {Array<Company>}
     * @memberof ImportSession
     */
    companies?: Array<Company> | null;
    /**
     * 
     * @type {Array<Order>}
     * @memberof ImportSession
     */
    orders?: Array<Order> | null;
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof ImportSession
     */
    invoices?: Array<Invoice> | null;
    /**
     * 
     * @type {Array<ImportRowError>}
     * @memberof ImportSession
     */
    rowErrors?: Array<ImportRowError> | null;
    /**
     * 
     * @type {Array<ImportStagingRecord>}
     * @memberof ImportSession
     */
    stagingRecords?: Array<ImportStagingRecord> | null;
    /**
     * 
     * @type {ImportMapping}
     * @memberof ImportSession
     */
    mapping?: ImportMapping;
    /**
     * 
     * @type {ImportConfiguration}
     * @memberof ImportSession
     */
    _configuration?: ImportConfiguration;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    validationTotalRows?: number | null;
}



/**
 * Check if a given object implements the ImportSession interface.
 */
export function instanceOfImportSession(value: object): value is ImportSession {
    return true;
}

export function ImportSessionFromJSON(json: any): ImportSession {
    return ImportSessionFromJSONTyped(json, false);
}

export function ImportSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'user': json['user'] == null ? undefined : ApplicationUserFromJSON(json['user']),
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'status': json['status'] == null ? undefined : ImportStatusFromJSON(json['status']),
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'importGroupId': json['importGroupId'] == null ? undefined : json['importGroupId'],
        'importGroup': json['importGroup'] == null ? undefined : ImportGroupFromJSON(json['importGroup']),
        'groupOrder': json['groupOrder'] == null ? undefined : json['groupOrder'],
        'fileUploads': json['fileUploads'] == null ? undefined : ((json['fileUploads'] as Array<any>).map(FileUploadFromJSON)),
        'companies': json['companies'] == null ? undefined : ((json['companies'] as Array<any>).map(CompanyFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(InvoiceFromJSON)),
        'rowErrors': json['rowErrors'] == null ? undefined : ((json['rowErrors'] as Array<any>).map(ImportRowErrorFromJSON)),
        'stagingRecords': json['stagingRecords'] == null ? undefined : ((json['stagingRecords'] as Array<any>).map(ImportStagingRecordFromJSON)),
        'mapping': json['mapping'] == null ? undefined : ImportMappingFromJSON(json['mapping']),
        '_configuration': json['configuration'] == null ? undefined : ImportConfigurationFromJSON(json['configuration']),
        'error': json['error'] == null ? undefined : json['error'],
        'validationTotalRows': json['validationTotalRows'] == null ? undefined : json['validationTotalRows'],
    };
}

export function ImportSessionToJSON(json: any): ImportSession {
    return ImportSessionToJSONTyped(json, false);
}

export function ImportSessionToJSONTyped(value?: ImportSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'userId': value['userId'],
        'user': ApplicationUserToJSON(value['user']),
        'importType': ImportTypeToJSON(value['importType']),
        'status': ImportStatusToJSON(value['status']),
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'importGroupId': value['importGroupId'],
        'importGroup': ImportGroupToJSON(value['importGroup']),
        'groupOrder': value['groupOrder'],
        'fileUploads': value['fileUploads'] == null ? undefined : ((value['fileUploads'] as Array<any>).map(FileUploadToJSON)),
        'companies': value['companies'] == null ? undefined : ((value['companies'] as Array<any>).map(CompanyToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(InvoiceToJSON)),
        'rowErrors': value['rowErrors'] == null ? undefined : ((value['rowErrors'] as Array<any>).map(ImportRowErrorToJSON)),
        'stagingRecords': value['stagingRecords'] == null ? undefined : ((value['stagingRecords'] as Array<any>).map(ImportStagingRecordToJSON)),
        'mapping': ImportMappingToJSON(value['mapping']),
        'configuration': ImportConfigurationToJSON(value['_configuration']),
        'error': value['error'],
        'validationTotalRows': value['validationTotalRows'],
    };
}

